import api from "./api";

const CheckpointApi = {
  async getCheckpoints(page = 0, pageSize = 25, status = null) {
    const params = { page, pageSize };
    if (status) {
      params.status = status;
    }
    const { result, error } = await api.fetch(`/checkpoints`, params);
    if (error) {
      throw error;
    }
    return result;
  },

  async getCheckpoint(blockNumber) {
    const { result, error } = await api.fetch(`/checkpoints/${blockNumber}`);
    if (error) {
      throw error;
    }
    return result;
  },

  async getLatestCheckpoints() {
    const { result, error } = await api.fetch(`/checkpoints/latest`);
    if (error) {
      throw error;
    }
    return result;
  },

  async getCheckpointStats() {
    const { result, error } = await api.fetch(`/checkpoints/stats`);
    if (error) {
      throw error;
    }
    return result;
  },

  // Get checkpoint status for a specific block
  async getBlockCheckpointStatus(blockNumber) {
    try {
      const checkpoint = await this.getCheckpoint(blockNumber);
      return checkpoint?.status || null;
    } catch (error) {
      // Block doesn't have a checkpoint
      return null;
    }
  },
};

export default CheckpointApi;
